export default __webpack_public_path__ + "static/media/premium-clock-icon-charge.a457402ed8666ae8fa96e085ed0ca72c.svg";